export const ACTIVE_SUBSCRIPTION_STATUSES = ['active', 'trialing', 'past_due'] as const

export type ActiveSubscriptionStatus = (typeof ACTIVE_SUBSCRIPTION_STATUSES)[number]

export function isSubscriptionActive(status: string | null | undefined): boolean {
  return (
    !!status && ACTIVE_SUBSCRIPTION_STATUSES.includes(status as ActiveSubscriptionStatus)
  )
}

export function isSubscriptionPastDue(status: string | null | undefined): boolean {
  return status === 'past_due'
}

const CARD_EXPIRY_FALLBACK_WINDOW_DAYS = 30

export function cardExpiryCutoff(expMonth: number, expYear: number): Date {
  return new Date(expYear, expMonth, 1)
}

export function hasCardExpired(params: {
  expMonth?: number
  expYear?: number
  now?: Date
}): boolean {
  const { expMonth, expYear } = params
  if (!expMonth || !expYear) return false
  const now = params.now ?? new Date()
  return cardExpiryCutoff(expMonth, expYear).getTime() <= now.getTime()
}

export function isCardExpiringBeforeRenewal(params: {
  expMonth?: number
  expYear?: number
  currentPeriodEnd?: string | null
  now?: Date
}): boolean {
  const { expMonth, expYear, currentPeriodEnd } = params
  if (!expMonth || !expYear) return false
  const now = params.now ?? new Date()
  const cutoff = cardExpiryCutoff(expMonth, expYear)
  if (currentPeriodEnd) {
    const renewal = new Date(currentPeriodEnd)
    if (!Number.isNaN(renewal.getTime())) {
      return cutoff.getTime() <= renewal.getTime()
    }
  }
  const fallbackHorizon = now.getTime() + CARD_EXPIRY_FALLBACK_WINDOW_DAYS * 24 * 60 * 60 * 1000
  return cutoff.getTime() <= fallbackHorizon
}

export type PromoCodeValidation = {
  valid: boolean
  promotionCodeId?: string
  name?: string
  percentOff?: number
  amountOff?: number
  trialDays?: number
  trialEndsAt?: string
}

export type SubscriptionTier = 'monthly' | 'annual'
export type Currency = 'usd' | 'cad'

export type CheckoutSession = {
  url: string
}

export type CheckoutConfirmation = {
  ok: boolean
  data?: unknown
  error?: string
}
